<template>
  <!--<div class="login">
    <p class="log-title">登录</p>
    <div class="log-logo"><img src="../assets/img/logo-87.png" alt="" /></div>
    <form action="">
      <div class="log-input">
        <p>学号/工号</p>
        <div :class="isFocus ? 'input-active' : 'input-item'">
          <input type="text" placeholder="请输入学号/工号" v-model.trim="account" autocomplete="user" @focus="lineChange(0)" @keyup.enter="loginSubmit()" />
          <i class="delete-icon" v-if="account" @click="deleteTap(0)"></i>
        </div>
      </div>
      <div class="log-input">
        <p>密码</p>
        <div :class="isFocus1 ? 'input-active' : 'input-item  '">
          <input type="password" placeholder="请输入密码" v-model="password" autocomplete="psw" @focus="lineChange(1)" @keyup.enter="loginSubmit()" />
          <i class="delete-icon" v-if="password" @click="deleteTap(1)"></i>
        </div>
      </div>
    </form>
    <div class="log-btn"><button @click="loginSubmit()">登录</button></div>
  </div>-->

  <section class="aui-flexView">
    <header class="aui-navBar aui-navBar-fixed">
      <a href="javascript:;" class="aui-navBar-item">
       <!-- <i class="icon icon-return"></i>-->
      </a>
      <div class="aui-center">
        <span class="aui-center-title"></span>
      </div>
    </header>
    <section class="aui-scrollView">
      <div class="aui-entry-box">
        <div class="aui-entry-head">
          <div class="aui-entry-img">
            <img src="../assets/img/head-title.png" alt="">
          </div>
          <div class="aui-flex-item">
            <div class="aui-flex b-line">
              <div class="aui-flex-icon">
                <img src="../assets/img/icon-user.png" alt="">
              </div>
              <div class="aui-flex-box">
                <input type="text" placeholder="请输入学号/工号" v-model.trim="account" autocomplete="user" @focus="lineChange(0)" @keyup.enter="loginSubmit()" >
                <i class="delete-icon" v-if="account" @click="deleteTap(0)"></i>
              </div>
            </div>
            <div class="aui-flex">
              <div class="aui-flex-icon">
                <img src="../assets/img/icon-psd.png" alt="">
              </div>
              <div class="aui-flex-box">
                <input type="password" placeholder="密码" v-model="password" autocomplete="psw" @focus="lineChange(1)" @keyup.enter="loginSubmit()">
                <i class="delete-icon" v-if="password" @click="deleteTap(1)"></i>
              </div>
            </div>
          </div>
          <div class="aui-entry-button">
            <button @click="loginSubmit()" >登录</button>
          </div>
          <div class="aui-entry-forget">
            <a href="#"  @click="ysxy" >隐私协议</a>
            <a href="#"  @click="wjmm" >忘记密码？</a>
          </div>
        </div>
        <div class="aui-entry-text">
          <p>第三方快速登录</p>
        </div>
        <div class="aui-entry-signs">
          <button @click="wxauth()"> <i class="icon icon-wx"></i> 微信</button>
         <!-- <button style="color:#38a9d3"><i class="icon icon-qq"></i>QQ</button>-->
        </div>
      </div>
      <van-dialog v-model="show" title="修改密码" :before-close="beforeClose" @confirm="handleConfirm">
        <van-form ref="myform" >
          <!-- 输入密码 -->
          <van-field v-model="formmm.oldPassword" style="padding: 10px 10px 10px 10px"
                     type="password"
                     label="旧密码"
                     placeholder="请输入旧密码"
                     :rules="[
            { required: true, message: '请输入旧密码' }
          ]"
          />
          <van-field v-model="formmm.newPassword" style="padding: 10px 10px 10px 10px"
                     type="password"
                     label="新密码"
                     placeholder="必须8位含数字大小写字母"
                     :rules="[
            { required: true, message: '请输入新密码' }
          ]"
          />
          <van-field v-model="formmm.confirmPassword" style="padding: 10px 10px 10px 10px"
                     type="password"
                     label="新密码确认"
                     placeholder="必须8位含数字大小写字母"
                     :rules="[
            { required: true, message: '请输入新密码' }
          ]"
          />
          <van-field v-model="formmm.email" style="padding: 10px 10px 10px 10px" v-show="showemail"
                     type="text"
                     label="邮箱"
                     placeholder="请输入邮箱，用于找回密码。"
                     :rules="[
            { required: showemail, message: '请输入邮箱' }
          ]"
          />
        </van-form>
      </van-dialog>

      <van-dialog  title="找回密码" v-model="Visible" :show-confirm-button="false" :show-cancel-button="false">
        <div v-show="zhmm">
          <div style="margin: 0 auto" >
            <van-form ref="formzh" :model="formzh" >
              <div>
                <van-field style="padding: 10px 10px 10px 10px"
                           v-model="formzh.account"
                           placeholder="请输入账号"
                />
              </div>
              <div style="width: 100%">
                <table style="width: 100%">
                  <tr>
                    <td>
                      <van-field style="padding: 10px 10px 10px 10px"
                                   v-model="formzh.yzm"
                                   placeholder="请输入验证码"
                      />
                    </td>
                    <td>
                      <van-button type="info" v-if="showyzm" @click="getyzm" style="padding: 10px 10px 10px 10px;width: 100%">
                        <span style="color: white">获取验证码</span>
                      </van-button>
                      <van-button type="default" v-if="!showyzm" style="padding: 10px 10px 10px 10px;width: 100%">{{ yzmtimes }}s</van-button>
                    </td>
                  </tr>
                </table>
              </div>
            </van-form>
          </div>
          <div style="text-align:center" >
            <van-button type="default" @click="cancel" style="width: 49%;height: 40px;">取消</van-button>
            <van-button type="default" @click="hdconfirm" style="width: 49%;height: 40px;">确认</van-button>
          </div>
        </div>
        <div v-show="!zhmm">
          <div style="margin: 0 auto" >
            <van-form ref="formmm2" :model="formmm2" >
                <van-field style="padding: 10px 10px 10px 10px"
                  v-model="formmm2.xmm" type="password"
                  placeholder="新密码必须8位含数字大小写字母"
                  show-password maxlength="18"
                />
                <van-field style="padding: 10px 10px 10px 10px"
                  v-model="formmm2.qrmm" type="password"
                  placeholder="新密码必须8位含数字大小写字母"
                  show-password maxlength="18"
                />
              <div style="text-align:center" >
              <van-button @click="pwdconfirm" style="width: 100%;height: 40px;">确认</van-button>
              </div>
            </van-form>
          </div>
        </div>
      </van-dialog>

      <van-dialog  title="用户服务协议和隐私政策" v-model="Visiblexy" :show-confirm-button="false" :show-cancel-button="false">
        <div style="height: 400px">
          <iframe style="height: 100%" src="../../static/ysxy.html"></iframe>
        </div>
        <div style="text-align:center" >
          <van-button type="default" @click="cancelxy" style="width: 49%;height: 40px;">取消</van-button>
          <van-button type="default" @click="confirmxy" style="width: 49%;height: 40px;">同意</van-button>
        </div>
      </van-dialog>
    </section>
  </section>
</template>

<script>
  import {Notify, Toast} from 'vant';
import { encrypt, decrypt } from '../utils/jsencrypt';
export default {
  name: 'Login',
  components: {},
  data() {
    return {
      account: '',
      password: '',
      isFocus: false,
      isFocus1: false,
      schoolcode: '',
      qrcodeId: '',
      code: '',
      show:false,
      pattern:/(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])[a-zA-Z0-9]{8,18}/,
      regularemail:/^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/,
      formmm:{
        oldPassword:null,
        newPassword:null,
        confirmPassword:null,
        email:null,
      },
      Visible:false,
      formzh: {
        account: null,
        yzm:null,
      },
      showyzm:true,
      yzmtimes:60,
      zhmm:true,
      formmm2: {
        account: null,
        yzm:null,
        xmm:null,
        qrmm:null,
      },
      showemail:false,
      Visiblexy:false,
    };
  },
  created() {
    let code = this.GetParam(window.location.href.split("#")[0],"code");
    //判断用户是否点击了注销登录，如点击了注销则不再判断微信直接登录
    let cancellation = this.GetParam(window.location.href.split("#")[0],"cancellation");
    if(!code && !cancellation)
    {
      //this.wxauth();
    }
    if(!code)
    {}
    else
    {
      this.qrcodeId = this.GetParam(window.location.href.split("#")[0],"qrcodeId");
      this.code = code;
      this.wxlogin();
    }
    let token = localStorage.getItem('Token');
    let that = this;
    this.$ajax.get('/getInfo').then(function(res) {
      if (res.code == 200 && token) {
        let user = res.user;
        if (user.usertype == '02') {
          localStorage.setItem('facecheck', 'true');

          that.$router.push('/studentmain');
        } else if (user.usertype == '01') {
          that.$router.push('/teachmain');
        }
        /*  if (localStorage.getItem('facecheck') == 'true') {
          let path = decodeURIComponent(localStorage.getItem('currentpath'));
          let params = JSON.parse(localStorage.getItem('currentpathparams'));
          console.log('backpath:', path, params);
          if (path != '' && path != undefined) that.$router.push({ path: path, params: params });
          else that.$router.push('/studentmain');
        } else {
          that.$router.push('/studentmain');
          //that.$router.push('/facecheck');
        }*/
      }
    });
    if(this.$cookies.get('jxsysxy') == null){
      this.$cookies.set('jxsysxy', '2')
      this.Visiblexy = true;
    }else{
      if(this.$cookies.get('jxsysxy') == '2'){
        this.Visiblexy = true;
      }
    }
  },
  methods: {
    async login() {
      localStorage.clear();
      const params = {
        username: this.account,
        password:  encrypt(this.password),
        qrcodeId: this.qrcodeId
      };
      const res = await this.$ajax.post('applogin',params);
      if (res.code == 500) {
        this.$toast.fail(res.msg);
      } else {
        let user = res.user;
        localStorage.setItem('Token', res.token);
        localStorage.setItem('Identity', user.usertype);
        localStorage.setItem('user', JSON.stringify(user));
        localStorage.setItem("aqjc",res.aqjc)
        if(res.aqjc == 'N'){
          this.$toast.fail("密码必须8位含数字大小写字母！");
          this.show = true;
          this.formmm.email = user.email;
          // if(user.email == null || user.email =="")
          // {
            this.showemail = true;
          // }
        }else{
          if (res.needrepwd) {
            this.$router.push('/changpass');
          } else if (user.usertype == '02') {
            localStorage.setItem('facecheck', 'true');
            this.$router.push('/studentmain');
          } else if (user.usertype == '01') {
            this.$router.push('/teachmain');
          }else
          {
            Toast.fail('请用学生或老师账号登录！');
          }
        }
      }
    },
    loginSubmit() {
      if(this.$cookies.get('jxsysxy') == '2'){
        this.Visiblexy = true;
      }else{
        if (this.account == '' || this.password == '') {
          Toast.fail('请填写账号或密码');
        } else {
          this.login();
        }
      }
    },
    deleteTap(val) {
      if (val == 0) {
        this.account = '';
      } else {
        this.password = '';
      }
    },

    lineChange(res) {
      if (res == 0) {
        this.isFocus = true;
        this.isFocus1 = false;
      } else {
        this.isFocus1 = true;
        this.isFocus = false;
      }
    },
    wxlogin()
    {
      const params = {
        qrcodeId: this.qrcodeId
      };
      let that = this;
       this.$ajax.post('/wechat/appwxlogin?code='+this.code,params).then(function(res) {
         if (res.code == 200) {
           let user = res.user;
           localStorage.setItem('Token', res.token);
           localStorage.setItem('Identity', user.usertype);
           localStorage.setItem('user', JSON.stringify(user));
           if (res.needrepwd) {
             that.$router.push('/changpass');
           } else if (user.usertype == '02') {
             localStorage.setItem('facecheck', 'true');
             that.$router.push('/studentmain');
           } else if (user.usertype == '01') {
             that.$router.push('/teachmain');
           }
         }
         else if(res.code==500)
         {
           that.$toast.fail("未绑定微信！请在5分钟内用账号密码登录自动绑定！");
         }
         else
         {
           that.$toast.fail(res.msg);
         }
       })
    },
    wxauth()
    {
      const params = {
        qrcodeId: this.qrcodeId
      };
      let that = this;
      this.$ajax.post('/wechat/appwxauth',params).then(function(res) {
        if (res.code == 200) {
          window.location.href = res.redirect_uri;
          that.qrcodeId = res.qrcodeId;
        }
        else
        {
          that.$toast.fail(res.msg);
        }

      })
    },
    GetParam(url, code) {
      url = url + "";
      let regstr = "/(\\?|\\&)" + code + "=([^\\&]+)/";
      let reg = eval(regstr);
      //eval可以将 regstr字符串转换为 正则表达式
      let result = url.match(reg);
      if (result && result[2]) {
        return result[2].replace("#/","");
      }
    },
    beforeClose(action, done) {
      if (action === "confirm") {
        return done(false);
      } else {
        // 重置表单
        this.formmm= {
          oldPassword: null,
          newPassword: null,
          confirmPassword: null,
          email:null,
        }
        return done();
      }
    },
    handleConfirm() {
      if(!this.pattern.test(this.formmm.newPassword) || this.formmm.newPassword.length<8)
      {
        Notify({type: 'danger', message: '新密码必须8位含数字大小写字母！'});
        return;
      }
      if (this.formmm.newPassword != this.formmm.confirmPassword) {
        Notify({type: 'danger', message: '两次输入的新密码不一致！'});
        return;
      }
      if(this.showemail){
        if(!this.regularemail.test(this.formmm.email))
        {
          Notify({type: 'danger', message: '邮箱格式不对！'});
          return;
        }
      }
      let oldPassword = this.formmm.oldPassword;
      let newPassword = this.formmm.newPassword;
      let email = this.formmm.email;
      const data = {
        oldPassword,
        newPassword,
        email
      }
      let that = this;
      this.$refs["myform"]
        .validate()
        .then(() => {
          this.$ajax.put('/system/user/profile/updatePwdapp', data).then(response => {
            if (response.code == 500) {
              this.formmm = {
                oldPassword: null,
                newPassword: null,
                confirmPassword: null,
                email:null,
              }
              Notify({type: 'danger', message: response.msg});
            } else {
              this.show = false; // 在这里手动的关闭弹窗
              Notify({type: 'success', message: "修改成功"});
              // 重置表单
              this.formmm = {
                oldPassword: null,
                newPassword: null,
                confirmPassword: null,
                email:null,
              }
              that.$ajax.post('/logout', {}).then(function(res) {
                if (res.code == 200) {
                  localStorage.clear();
                  localStorage.removeItem("Token");
                  location.href = '/login?cancellation=1';
                }
              });
            }
          });
        })
        .catch(() => {
        });
    },
    wjmm(){
      this.Visible = true;
    },
    cancel(){
      this.Visible = false;
    },
    pwdconfirm(){
      if(this.formmm2.xmm == null || this.formmm2.xmm == ''){
        Notify({type: 'danger', message: '请输入新密码！'});
        return;
      }
      if(!this.pattern.test(this.formmm2.xmm) || this.formmm2.xmm.length<8){
        Notify({type: 'danger', message: '新密码必须8位含数字大小写字母！'});
        return;
      }
      if(this.formmm2.qrmm != this.formmm2.xmm){
        Notify({type: 'danger', message: '确认密码和新密码不一致！'});
        return;
      }
      this.$ajax.put('/wjmm', this.formmm2).then(response => {
        if(response.code == "200") {
          Notify({type: 'success', message: '成功！'});
          this.formmm2.xmm = null;
          this.formmm2.qrmm = null;
          this.formzh.account = null;
          this.formzh.yzm = null;
          this.zhmm = true;
          this.Visible = false;
        }else{
          Notify({type: 'danger', message: response.msg});
        }
      })
    },
    getyzm(){
      if(this.formzh.account == null || this.formzh.account == ''){
        Notify({type: 'danger', message: '请输入账号！'});
        return;
      }
      this.showyzm = false
      this.$ajax.put('/fsyzm', this.formzh).then(response => {
        if(response.code == "200") {
          Notify({type: 'success', message: '发送成功！'});
        }else{
          Notify({type: 'danger', message: response.msg});
        }
      })
      this.timer = setInterval(()=>{
        this.yzmtimes--
        if(this.yzmtimes===0){
          this.showyzm = true
          this.yzmtimes = 60
          clearInterval(this.timer)
        }
      },1000)
    },
    hdconfirm(){
      if(this.formzh.account == null || this.formzh.account == ''){
        Notify({type: 'danger', message: '请输入账号！'});
        return;
      }
      if(this.formzh.yzm == null || this.formzh.yzm == ''){
        Notify({type: 'danger', message: '请输入验证码！'});
        return;
      }
      this.$ajax.put('/hdyzm', this.formzh).then(response => {
        if(response.code == "200"){
          this.formmm2.account = this.formzh.account;
          this.formmm2.yzm = this.formzh.yzm;
          this.zhmm = false
        }else{
          Notify({type: 'danger', message: response.msg});
        }
      });
    },
    ysxy(){
      this.Visiblexy = true;
    },
    cancelxy(){
      this.Visiblexy = false;
      this.$cookies.set('jxsysxy', '2')
    },
    confirmxy(){
      this.Visiblexy = false;
      this.$cookies.set('jxsysxy', '1')
    }
  },

  mounted() {}
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  @import url('../assets/css/loginstyle.css');
  .delete-icon {
    background: url(../assets/delete.png) no-repeat center;
    width: 16px;
    height: 16px;
    background-size: 16px 16px;
  }
</style>



// WEBPACK FOOTER //
// src/components/login.vue